module.exports = __webpack_public_path__ + "img/hand.cac7dd0c.png";